<!-- eslint-disable vue/no-v-html -->
<script>
import { formatDashboardAmount } from '@/utils/format'

export default {
  name: 'Amount',
  props: {
    amount: {
      type: [Number, String],
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    align: {
      type: String,
      default: 'start',
    },
  },
  computed: {
    formattedAmount() {
      const amount = Number(this.amount)

      return formatDashboardAmount(
        {
          amount: isNaN(amount) ? 0 : amount,
          currency: this.currency,
        },
        {
          removeZeroDecimalPart: false,
        }
      )
    },
    alignClass() {
      return (
        {
          start: 'justify-start',
          center: 'justify-center',
          end: 'justify-end',
        }[this.align] || ''
      )
    },
  },
}
</script>

<template>
  <div
    :dir="currency === 'SAR' ? 'ltr' : ''"
    class="tamara-amount global__font-currency-primary"
    :class="alignClass"
    v-html="formattedAmount"
  />
</template>

<style lang="scss">
.tamara-amount {
  display: flex;
  gap: 4px;
  align-items: center;

  .amount {
    font-family: var(--font-primary);
  }
}
</style>
